const adminConstants = {};

adminConstants.CREATE_ADMIN = 'CREATE_ADMIN';
adminConstants.LIST_ADMIN = 'LIST_ADMIN';
adminConstants.RETRIEVE_ADMIN = 'RETRIEVE_ADMIN';
adminConstants.UPDATE_ADMIN = 'UPDATE_ADMIN';
adminConstants.DESTROY_ADMIN = 'DESTROY_ADMIN';

adminConstants.LOGIN_ADMIN = 'LOGIN_ADMIN';
adminConstants.LOGOUT_ADMIN = 'LOGOUT_ADMIN';
adminConstants.FORGOT_PASSWORD_ADMIN = 'FORGOT_PASSWORD_ADMIN';
adminConstants.RESET_PASSWORD_ADMIN = 'RESET_PASSWORD_ADMIN';
adminConstants.CONFIRM_EMAIL = 'CONFIRM_EMAIL';

export default adminConstants;



/** WEBPACK FOOTER **
 ** ./src/constants/admin.js
 **/